import React from 'react';

const DashboardSVG = () => {
  return (
    <>
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.888 5.24738C19.487 4.7668 20.232 4.50488 21 4.50488C21.768 4.50488 22.513 4.7668 23.112 5.24738L34.737 14.5729C35.1312 14.8891 35.4493 15.2898 35.6679 15.7455C35.8865 16.2011 36 16.7 36 17.2054V34.1254C36 35.0205 35.6444 35.8789 35.0115 36.5119C34.3785 37.1448 33.5201 37.5004 32.625 37.5004H28.875C27.9799 37.5004 27.1215 37.1448 26.4885 36.5119C25.8556 35.8789 25.5 35.0205 25.5 34.1254V24.3754C25.5 24.077 25.3815 23.7909 25.1705 23.5799C24.9595 23.3689 24.6734 23.2504 24.375 23.2504H17.625C17.3266 23.2504 17.0405 23.3689 16.8295 23.5799C16.6185 23.7909 16.5 24.077 16.5 24.3754V34.1254C16.5 35.0205 16.1444 35.8789 15.5115 36.5119C14.8785 37.1448 14.0201 37.5004 13.125 37.5004H9.375C8.47989 37.5004 7.62145 37.1448 6.98851 36.5119C6.35558 35.8789 6 35.0205 6 34.1254V17.2054C6 16.1809 6.465 15.2134 7.263 14.5729L18.888 5.24738Z"
          className="sidenav-SVG"
        />
      </svg>
    </>
  );
};

const IDCardSVG = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5625 7.875C4.40344 7.875 2.625 9.65344 2.625 11.8125V30.1875C2.625 32.3466 4.40344 34.125 6.5625 34.125H35.4375C37.5966 34.125 39.375 32.3466 39.375 30.1875V11.8125C39.375 9.65344 37.5966 7.875 35.4375 7.875H6.5625ZM9.1875 18.375C9.1875 15.4875 11.55 13.125 14.4375 13.125C17.325 13.125 19.6875 15.4875 19.6875 18.375C19.6875 19.8371 19.0614 21.1536 18.0876 22.1077C18.9809 22.7106 19.7134 23.5228 20.221 24.4735C20.7286 25.4243 20.9961 26.4847 21 27.5625H18.375C18.375 25.3732 16.6267 23.625 14.4375 23.625C12.2483 23.625 10.5 25.3732 10.5 27.5625H7.875C7.87895 26.4847 8.14638 25.4243 8.65401 24.4735C9.16164 23.5228 9.89405 22.7106 10.7874 22.1077C9.81356 21.1536 9.1875 19.8358 9.1875 18.375ZM23.625 17.0625V14.4375H34.125V17.0625H23.625ZM23.625 22.3125V19.6875H34.125V22.3125H23.625ZM23.625 24.9375V27.5625H30.1875V24.9375H23.625Z"
      className="sidenav-SVG"
    />
    <path
      d="M17.0625 18.375C17.0625 16.9089 15.9036 15.75 14.4375 15.75C12.9714 15.75 11.8125 16.9089 11.8125 18.375C11.8125 19.8411 12.9714 21 14.4375 21C15.9036 21 17.0625 19.8411 17.0625 18.375Z"
      className="sidenav-SVG"
    />
  </svg>
);

const CoverageSVG = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.8765 19.1732C18.7018 18.4634 19.7791 17.8502 20.9992 17.8502C22.2193 17.8502 23.2966 18.4634 24.1219 19.1732C24.5613 19.5512 24.959 19.975 25.3084 20.4374L25.3756 20.534C25.4715 20.6778 25.6014 20.7957 25.7538 20.8773C25.9062 20.9588 26.0764 21.0015 26.2492 21.0015C26.4221 21.0015 26.5922 20.9588 26.7446 20.8773C26.897 20.7957 27.0269 20.6778 27.1228 20.534L27.19 20.4374C27.5392 19.9742 27.937 19.5497 28.3765 19.1711C29.2018 18.4634 30.2791 17.8502 31.4992 17.8502C32.7193 17.8502 33.7966 18.4634 34.6219 19.1732C35.0613 19.5512 35.459 19.975 35.8084 20.4374L35.8756 20.534C36.0007 20.7216 36.1828 20.8639 36.3951 20.94C36.6073 21.016 36.8384 21.0217 37.0541 20.9562C37.2699 20.8908 37.4588 20.7576 37.593 20.5764C37.7272 20.3952 37.7995 20.1757 37.7992 19.9502C37.7992 12.0206 31.0288 4.2002 20.9992 4.2002C10.9696 4.2002 4.19922 12.0206 4.19922 19.9502C4.19894 20.1757 4.27124 20.3952 4.40543 20.5764C4.53961 20.7576 4.72854 20.8908 4.94428 20.9562C5.16003 21.0217 5.39111 21.016 5.60336 20.94C5.81561 20.8639 5.99774 20.7216 6.12282 20.534L6.19002 20.4374C6.53928 19.9742 6.93704 19.5497 7.37652 19.1711C8.20182 18.4655 9.27912 17.8502 10.4992 17.8502C11.7193 17.8502 12.7966 18.4634 13.6219 19.1732C14.0613 19.5512 14.459 19.975 14.8084 20.4374L14.8756 20.5319C14.9715 20.6757 15.1014 20.7936 15.2538 20.8752C15.4062 20.9567 15.5764 20.9994 15.7492 20.9994C15.9221 20.9994 16.0922 20.9567 16.2446 20.8752C16.397 20.7936 16.5269 20.6757 16.6228 20.5319L16.69 20.4374C17.0393 19.9742 17.437 19.5497 17.8765 19.1711V19.1732ZM20.9992 19.9502C20.68 19.9502 20.3272 20.0552 19.9492 20.2652V33.0752C19.9492 33.7714 19.6727 34.4391 19.1804 34.9314C18.6881 35.4236 18.0204 35.7002 17.3242 35.7002C16.628 35.7002 15.9603 35.4236 15.4681 34.9314C14.9758 34.4391 14.6992 33.7714 14.6992 33.0752V32.5502C14.6992 32.2717 14.5886 32.0046 14.3917 31.8077C14.1948 31.6108 13.9277 31.5002 13.6492 31.5002C13.3707 31.5002 13.1037 31.6108 12.9068 31.8077C12.7098 32.0046 12.5992 32.2717 12.5992 32.5502V33.0752C12.5992 34.3283 13.097 35.5302 13.9831 36.4163C14.8692 37.3024 16.0711 37.8002 17.3242 37.8002C18.5774 37.8002 19.7792 37.3024 20.6653 36.4163C21.5514 35.5302 22.0492 34.3283 22.0492 33.0752V20.2652C21.7317 20.0726 21.3703 19.9642 20.9992 19.9502Z"
      className="sidenav-SVG"
    />
  </svg>
);

const ClaimsSVG = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.6528 12.5266C33.8744 12.7542 34 13.0616 34 13.3842V36.7857C34 37.4574 33.4719 38 32.8182 38H9.18182C8.52812 38 8 37.4574 8 36.7857V5.21429C8 4.54263 8.52812 4 9.18182 4H24.8668C25.1807 4 25.4835 4.12902 25.7051 4.3567L33.6528 12.5266ZM31.2744 13.942L24.3239 6.80045V13.942H31.2744ZM13.9091 19.8616C13.8307 19.8616 13.7556 19.8936 13.7002 19.9505C13.6448 20.0075 13.6136 20.0847 13.6136 20.1652V21.9866C13.6136 22.0671 13.6448 22.1443 13.7002 22.2013C13.7556 22.2582 13.8307 22.2902 13.9091 22.2902H28.0909C28.1693 22.2902 28.2444 22.2582 28.2998 22.2013C28.3552 22.1443 28.3864 22.0671 28.3864 21.9866V20.1652C28.3864 20.0847 28.3552 20.0075 28.2998 19.9505C28.2444 19.8936 28.1693 19.8616 28.0909 19.8616H13.9091ZM13.9091 25.0223C13.8307 25.0223 13.7556 25.0543 13.7002 25.1112C13.6448 25.1682 13.6136 25.2454 13.6136 25.3259V27.1473C13.6136 27.2278 13.6448 27.305 13.7002 27.362C13.7556 27.4189 13.8307 27.4509 13.9091 27.4509H20.7045C20.7829 27.4509 20.8581 27.4189 20.9135 27.362C20.9689 27.305 21 27.2278 21 27.1473V25.3259C21 25.2454 20.9689 25.1682 20.9135 25.1112C20.8581 25.0543 20.7829 25.0223 20.7045 25.0223H13.9091Z"
      className="sidenav-SVG"
    />
  </svg>
);

const AccountSVG = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.7084 13H16.2922C16.2922 13 9 19.9466 9 28.0534C9 32.6835 12.1359 35 14.2081 35H28.7919C30.8728 35 34 32.6833 34 28.0534C34 19.9466 26.7078 13 26.7078 13H26.7084ZM22.5407 29.093V30.947H20.4598L20.4596 29.0992C18.9258 28.7822 17.9624 27.7302 17.894 26.2026H19.6986C19.7869 27.0044 20.5139 27.521 21.5658 27.521C22.535 27.521 23.222 26.9982 23.222 26.2535C23.222 25.6197 22.7773 25.2583 21.6827 24.9859L20.5224 24.7103C18.8974 24.3331 18.0992 23.3919 18.0992 21.8802C18.0992 20.3686 19.0058 19.2783 20.4483 18.9202V17.0534H22.5292V18.9231C23.9374 19.2717 24.8754 20.3396 24.9209 21.7752L23.1792 21.7754C23.0909 20.9927 22.4351 20.4699 21.5344 20.4699C20.6336 20.4699 19.9835 20.9516 19.9835 21.7058C19.9835 22.3175 20.4083 22.6566 21.4544 22.9164L22.5292 23.1699C24.3222 23.5882 25.0947 24.4375 25.0947 25.9873C25.0949 27.6446 24.1371 28.7539 22.5407 29.093L22.5407 29.093Z"
      className="sidenav-SVG"
    />
    <path
      d="M27.7532 7.19535H24.2965C23.5824 6.43445 22.5664 6 21.5002 6C20.434 6 19.418 6.43447 18.7039 7.19535H15.2472C14.8337 7.19695 14.4479 7.39469 14.2159 7.72341C13.9838 8.05214 13.9356 8.46987 14.087 8.83966L15.2472 12H27.7528L28.913 8.83966C29.0644 8.46987 29.0162 8.05216 28.7841 7.72341C28.5521 7.39467 28.1663 7.19696 27.7528 7.19535H27.7532Z"
      className="sidenav-SVG"
    />
  </svg>
);

const FindProviderSVG = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.0135 13.8925C27.1936 13.0996 27.2997 12.311 27.2997 11.567C27.2997 8.09383 24.4708 5.26465 20.9973 5.26465C17.5241 5.26465 14.7003 8.09353 14.7003 11.567C14.7003 12.3112 14.8063 13.1003 14.9865 13.8937C14.5384 14.1587 14.1931 14.631 14.1734 15.2333C14.1734 16.7481 15.3266 17.7184 16.539 17.8436C16.8062 18.6058 17.2616 19.28 17.8515 19.8081V22.067H16.2739L16.2734 27.4133C16.8819 27.6315 17.3244 28.2101 17.3244 28.8898C17.3244 29.7535 16.614 30.4669 15.7504 30.4669C14.8867 30.4669 14.1733 29.7535 14.1733 28.8898C14.1733 28.2113 14.6155 27.6334 15.2233 27.4142V22.156C11.9525 22.662 9.44922 25.4782 9.44922 28.8916V36.2416C9.44922 36.5315 9.6843 36.7666 9.97422 36.7666L32.0242 36.7668C32.3141 36.7668 32.5492 36.5317 32.5492 36.2418V28.8918C32.5492 25.4786 30.0466 22.6626 26.7763 22.1562V26.8475C27.97 27.0929 28.8721 28.1525 28.8721 29.4172V29.9401C28.8883 30.6559 27.8059 30.6559 27.8221 29.9401V29.4172C27.8221 28.5355 27.1307 27.8443 26.2492 27.8443C25.3675 27.8443 24.6752 28.5356 24.6752 29.4172V29.9401C24.6906 30.6554 23.6097 30.6554 23.6252 29.9401V29.4172C23.6252 28.1509 24.5299 27.0898 25.7261 26.8465L25.7252 22.0672H24.1481V19.8052C24.7373 19.2774 25.1925 18.6057 25.4585 17.8438C26.6709 17.7193 27.822 16.7492 27.822 15.2335C27.802 14.6312 27.4605 14.1574 27.0135 13.8925ZM22.0518 12.5666C22.4435 13.1057 23.0555 13.6668 24.1488 13.6668H24.6759V16.2908C24.6759 18.3358 23.0428 19.9649 20.9978 19.9649C18.9529 19.9649 17.3238 18.336 17.3238 16.2908V13.6668H19.9478C21.0428 13.6668 21.6605 13.1062 22.0518 12.5666ZM16.2738 16.2908C16.2738 16.4434 16.2841 16.5932 16.2984 16.742C15.7108 16.5681 15.228 16.0818 15.228 15.2533C15.228 14.762 15.9691 14.4963 16.2738 14.8954L16.2738 16.2908ZM25.7046 16.7411C25.7187 16.593 25.7271 16.443 25.7271 16.2908V14.8942C25.9966 14.5103 26.7729 14.7358 26.7729 15.2521C26.7729 16.0736 26.291 16.567 25.7046 16.7411ZM23.099 20.5175V22.4216L20.9981 25.3592L18.9023 22.4216V20.5194C19.5346 20.8337 20.2443 21.0146 20.9981 21.0146C21.7535 21.0146 22.4652 20.833 23.099 20.5175ZM15.7514 28.3667C15.4552 28.3667 15.2243 28.5936 15.2243 28.8896C15.2243 29.1859 15.4552 29.4167 15.7514 29.4167C16.0477 29.4167 16.2743 29.1859 16.2743 28.8896C16.2743 28.5934 16.0474 28.3667 15.7514 28.3667Z"
      className="sidenav-SVG"
    />
  </svg>
);

const ResourcesSVG = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 11H14C13.2044 11 12.4413 11.3161 11.8787 11.8787C11.3161 12.4413 11 13.2044 11 14V28C11 28.7956 11.3161 29.5587 11.8787 30.1213C12.4413 30.6839 13.2044 31 14 31H26C26.7956 31 27.5587 30.6839 28.1213 30.1213C28.6839 29.5587 29 28.7956 29 28V20H23C22.2044 20 21.4413 19.6839 20.8787 19.1213C20.3161 18.5587 20 17.7956 20 17V11ZM29 18V17.828C28.9996 17.0328 28.6834 16.2702 28.121 15.708L24.293 11.878C23.7304 11.3157 22.9674 10.9999 22.172 11H22V17C22 17.2652 22.1054 17.5196 22.2929 17.7071C22.4804 17.8946 22.7348 18 23 18H29Z"
      className="sidenav-SVG"
    />
  </svg>
);

const UploadDocumentSVG = () => (
  <svg
    width="29"
    height="23"
    viewBox="0 0 29 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.998047 5.92188H26.6145C27.1373 5.92188 27.6385 6.12948 28.0077 6.49917C28.3774 6.86842 28.585 7.36963 28.585 7.89237V21.0288C28.585 21.5518 28.3774 22.053 28.0077 22.422C27.6384 22.7919 27.1372 22.9993 26.6145 22.9993H2.96854C2.44579 22.9993 1.94456 22.7919 1.57535 22.422C1.20566 22.053 0.998047 21.5518 0.998047 21.0288V5.92188Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3355 1.98156C15.2389 1.7071 15.0813 1.45484 14.871 1.24527C14.502 0.875361 14.0008 0.667969 13.478 0.667969H2.96854C2.44579 0.667969 1.94456 0.875355 1.57535 1.24527C1.20566 1.6143 0.998047 2.1155 0.998047 2.63847V4.60896H2.31164V3.95205C2.31164 2.86366 3.19374 1.98156 4.28213 1.98156H15.3355Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9574 4.61069H3.62549V3.95378C3.62549 3.59113 3.91975 3.29688 4.28217 3.29688H25.3012C25.6636 3.29688 25.9579 3.59113 25.9579 3.95378L25.9574 4.61069Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.998047 5.92188H26.6145C27.1373 5.92188 27.6385 6.12948 28.0077 6.49917C28.3774 6.86842 28.585 7.36963 28.585 7.89237V21.0288C28.585 21.5518 28.3774 22.053 28.0077 22.422C27.6384 22.7919 27.1372 22.9993 26.6145 22.9993H2.96854C2.44579 22.9993 1.94456 22.7919 1.57535 22.422C1.20566 22.053 0.998047 21.5518 0.998047 21.0288V5.92188Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3355 1.98156C15.2389 1.7071 15.0813 1.45484 14.871 1.24527C14.502 0.875361 14.0008 0.667969 13.478 0.667969H2.96854C2.44579 0.667969 1.94456 0.875355 1.57535 1.24527C1.20566 1.6143 0.998047 2.1155 0.998047 2.63847V4.60896H2.31164V3.95205C2.31164 2.86366 3.19374 1.98156 4.28213 1.98156H15.3355Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9574 4.61069H3.62549V3.95378C3.62549 3.59113 3.91975 3.29688 4.28217 3.29688H25.3012C25.6636 3.29688 25.9579 3.59113 25.9579 3.95378L25.9574 4.61069Z"
      fill="white"
    />
  </svg>
);

const EstimateCosttSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="white"
    >
      <path d="M17.6944 33.75V30.8409H8.80556C7.82778 30.8409 6.99044 30.5563 6.29356 29.9871C5.59785 29.4169 5.25 28.7318 5.25 27.9318V7.56818C5.25 6.76818 5.59785 6.08309 6.29356 5.51291C6.99044 4.9437 7.82778 4.65909 8.80556 4.65909H17.6944V1.75H21.25V33.75H17.6944ZM8.80556 26.4773H17.6944V17.75L8.80556 26.4773ZM24.8056 30.8409V17.75L33.6944 26.4773V7.56818H24.8056V4.65909H33.6944C34.6722 4.65909 35.5096 4.9437 36.2064 5.51291C36.9021 6.08309 37.25 6.76818 37.25 7.56818V27.9318C37.25 28.7318 36.9021 29.4169 36.2064 29.9871C35.5096 30.5563 34.6722 30.8409 33.6944 30.8409H24.8056Z" />
    </svg>
  );
};

export {
  DashboardSVG,
  IDCardSVG,
  CoverageSVG,
  ClaimsSVG,
  AccountSVG,
  FindProviderSVG,
  ResourcesSVG,
  UploadDocumentSVG,
  EstimateCosttSVG,
};
